import React from 'react';
import { Helmet } from "react-helmet-async";
import Breadcrumb from '../../components/Breadcrumb';
import About from './AboutSection';
import Course from './CourseSection';
import FunFact from './FunFactSection';
import CareerThree from './CareerSectionThree';
import Testimonial from './TestimonialSection';

const AboutMain = () => {
  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />
        {/* OLD TITLE COMMENTED */}
        {/* <title>About Central Books | 75+ Years of Experience in Education</title> */}
        <title> About CBS HUB | 75+ Years B2B School Supply Expertise | Central Books </title>
        {/* <meta name="description" content="Learn more about Central Books, our history, and our commitment to providing quality educational services. With a legacy of over 75 years, we are dedicated to supporting schools and students with innovative solutions." /> */}
        <meta  name="description" content="CBS HUB Private Limited (Central Books) — 75+ years serving 450+ schools & 9 million+ students in Hyderabad, Telangana, AP & Pan-India with books, kits, stationery & library solutions." />
        <meta name="keywords" content="about Central Books, CBS HUB Hyderabad, B2B school supplier history, school book distributor 75 years, educational supplier Hyderabad Telangana"/>
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Central Books" />
        <meta httpEquiv="content-language" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://www.centralbooks.in/about-us" />
        <meta property="og:title" content="About CBS HUB | 75+ Years B2B School Supply Expertise | Central Books" />
        <meta property="og:description" content="CBS HUB Private Limited (Central Books) — 75+ years serving 450+ schools & 9 million+ students in Hyderabad, Telangana, AP & Pan-India with books, kits, stationery & library solutions."/>
        <meta property="og:image" content="https://www.centralbooks.in/images/about-us-og.jpg"/>
        <meta property="og:url" content="https://www.centralbooks.in/about-us" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Central Books" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About CBS HUB | 75+ Years B2B School Supply Expertise | Central Books" />
        <meta name="twitter:description" content="CBS HUB Private Limited (Central Books) — 75+ years serving 450+ schools & 9 million+ students in Hyderabad, Telangana, AP & Pan-India with books, kits, stationery & library solutions." />
        <meta name="twitter:image" content="https://www.centralbooks.in/images/about-us-og.jpg" />
        {/* EXISTING SCHEMA KEPT */}
        <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org",
            "@type":"Organization",
            name:"Central Books",
            url:"https://centralbooks.in/about-us",
            logo: "https://centralbooks.in/static/media/logo-white.6970e86702604974eb88.png", })}
        </script>

        {/* NEW BREADCRUMB SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.centralbooks.in/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "About Us",
                item: "https://www.centralbooks.in/about-us",
              },
            ],
          })}
        </script>

        {/* NEW ABOUT PAGE SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About CBS HUB Private Limited",
            url: "https://www.centralbooks.in/about-us",
            mainEntity: {
              "@type": "Organization",
              name: "CBS HUB Private Limited",
              foundingDate: "1949",
              numberOfEmployees: {
                "@type": "QuantitativeValue",
                value: 250,
              },
              areaServed: "India",
            },
          })}
        </script>
      </Helmet>
      <Breadcrumb title="about us" />
      <About />
      <FunFact />
      <Testimonial />
      <Course />
      <CareerThree />
    </main>
  );
};
export default AboutMain;
